import React from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider, SignedIn, SignedOut } from "@clerk/clerk-react";
import { AuthenticatedApp, AuthRoutes } from "./App";
import { isProductionBuild, readPublicConfig, type PublicConfig } from "./config";
import { initObservability } from "./observability";
import "./styles.css";
import codessaMark from "../../../Logos/codessa-mark-paper.svg";

initObservability();

const root = document.getElementById("root");
if (!root) throw new Error("Codessa Cloud root element is missing.");

if (window.location.pathname.replace(/\/+$/, "") === "/desktop-sign-in") {
  // Bridge page the Codessa desktop app opens in the system browser to complete
  // its sign-in via this app's Clerk instance, wrapped in the same
  // ClerkProvider the main app below uses.
  void import("./DesktopSignIn").then(({ DesktopSignIn }) => {
    let config: PublicConfig;
    try {
      config = readPublicConfig();
    } catch (error) {
      createRoot(root).render(<ConfigurationError message={error instanceof Error ? error.message : "Cloud configuration is incomplete."} production={isProductionBuild()} />);
      return;
    }
    createRoot(root).render(
      <React.StrictMode>
        <ClerkProvider publishableKey={config.clerkPublishableKey} afterSignOutUrl="/login">
          <DesktopSignIn />
        </ClerkProvider>
      </React.StrictMode>,
    );
  });
} else {

let config: PublicConfig;
try {
  config = readPublicConfig();
} catch (error) {
  createRoot(root).render(<ConfigurationError message={error instanceof Error ? error.message : "Cloud configuration is incomplete."} production={isProductionBuild()} />);
  config = null as unknown as PublicConfig;
}

if (config) {
  createRoot(root).render(
    <React.StrictMode>
      <ClerkProvider publishableKey={config.clerkPublishableKey} afterSignOutUrl="/login">
        <SignedIn><AuthenticatedApp config={config} /></SignedIn>
        <SignedOut><AuthRoutes config={config} /></SignedOut>
      </ClerkProvider>
    </React.StrictMode>,
  );
}
}

function ConfigurationError({ message, production }: { message: string; production: boolean }) {
  return <main className="config-error"><img className="brand-symbol" src={codessaMark} alt="" /><h1>Codessa Cloud is not configured</h1><p>{message}</p><p className="muted-copy">{production ? "The deployment is missing a required public configuration value. No fake sign-in or workspace state is available." : "Set the VITE_CLERK_PUBLISHABLE_KEY, VITE_CLERK_JWT_TEMPLATE, and VITE_CODESSA_RELAY_URL values before starting the browser client."}</p></main>;
}
